export const peopleHistoryMappings = {
  createdAt: 'Created On',
  createdBy: 'Created By',
  lastUpdatedAt: 'Updated On',
  lastUpdatedBy: 'Updated By'
};

export const defaultColumnMappings = {
  photo: '',
  name: 'Name',
  preview: '',
  actions: '',
  database: 'Database',
  email: 'Email',
  jobTitle: 'Job Title',
  companyName: 'Company',
  lastContacted: 'Last Contacted'
};

export const excludedColumns = [
  'photo',
  'name',
  'preview',
  'actions',
  'database',
  'jobTitle'
];

export const sortableColumnTypes = {
  companyName: 'alpha',
  createdAt: 'amount',
  createdBy: 'alpha',
  email: 'alpha',
  lastContacted: 'alpha',
  lastUpdatedAt: 'amount',
  lastUpdatedBy: 'alpha'
};

export const peopleInformationMappings = {
  historyInformation: {
    title: 'History',
    mappings: peopleHistoryMappings,
    key: 'history-mappings'
  }
};